module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/black-4413c963224c3e0caf36f2e2d873784d.png";